require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./recipes-coconut-burfi.json") })
        }
      }, "path---recipes-coconut-burfi");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---recipes-coconut-burfi!./.cache/json/recipes-coconut-burfi.json
// module id = 729
// module chunks = 231608221292675